export const getPevLocation = location => {
  const link = location.split('/');
  link.pop();
  return link.join('/');
}
